goog.provide("shadow.js.shim.module$src$svg$arrows$arrow_trend_up_svg");
goog.provide("module$shadow_js_shim_module$src$svg$arrows$arrow_trend_up_svg");
shadow.js.shim.module$src$svg$arrows$arrow_trend_up_svg = shadow.js.nativeProvides["src/svg/arrows/arrow-trend-up.svg"] = shadow$bridge("src/svg/arrows/arrow-trend-up.svg");
module$shadow_js_shim_module$src$svg$arrows$arrow_trend_up_svg.default = shadow.js.shim.module$src$svg$arrows$arrow_trend_up_svg;
